import mitt, { type Emitter } from 'mitt';

type Events = {
  'onboarding:set-planning-tab': number;
  'onboarding:last-folder-added': void;
  'onboarding:close-ingredient-sidebar': void;
  'onboarding:choose-folder-dialog-opened': void;
  'onboarding:history-menu-opened': void;
  'onboarding:ingredient-clicked': void;
  'onboarding:generated-images-ready': void;
  'onboarding:recipe-summary-ready': void;
  'onboarding:recipe-list-ready': void;
  'onboarding:request-open-recipe-actions': void;
  'onboarding:add-tag-clicked': void;
  'onboarding:recipe-detail-loaded': void;
  'onboarding:recipe-suggestion-clicked': void;
  'onboarding:dialog-canceled-by-user': void;
  'onboarding:dialog-canceled-by-user-during-dish-generation': void;
  'onboarding:dialog-canceled-by-user-during-tags-selection': void;
  'onboarding:dialog-close-dishes-validation': void;
};

const emitter: Emitter<Events> = mitt<Events>();

export const useEventBus = () => {
  return {
    emit: emitter.emit,
    on: emitter.on,
    off: emitter.off,
  };
};
